import { PagedVirtualScrollerComponent } from '@shared/components/paged-virtual-scroller/paged-virtual-scroller.component';
import { NewsStatusEnum } from '@collections/news/enums/news.enums';
import {
  Component, OnInit, ViewEncapsulation
} from '@angular/core';
import { NewsGQL, NewsResponse } from '@shared/services/news/news.gql.service';
import { NewsTypeEnum } from '@collections/news/enums/news.enums';
import { LanguagesService } from '@shared/services/languages/languages.service';
import { QueryRef } from 'apollo-angular';
import { UsersService } from 'app/shared/services/users/users.service';
import { NewsBlockSocialComponent } from '../../../../news/views/news-block-social/news-block-social.component';
import { PagedVirtualScrollerComponent as PagedVirtualScrollerComponent_1 } from '../../../../shared/components/paged-virtual-scroller/paged-virtual-scroller.component';
import { FiltersComponent } from '../../../../shared/components/filters/filters.component';
import { CarouselBannerComponent } from '../../../../shared/components/carousel-banner/carousel-banner.component';
import { ToolbarHallsComponent } from '../../../../layout/components/toolbar-halls/toolbar-halls.component';
import { RenderIfDirective } from '../../../../shared/directives/render-if.directive';
import { NewsArchiveHeaderComponent } from '../news-archive-header/news-archive-header.component';
import { NewsArchiveHeaderResponsiveComponent } from '../news-archive-headerResponsive/news-archive-headerResponsive.component';
import { NewsBlockComponent } from '../../../../news/views/news-block/news-block.component';
import { BlockHorizontalScrollerComponent } from '../../../../shared/components/block-horizontal-scroller/block-horizontal-scroller.component';
import { FooterComponent } from '../../../../layout/components/footer/footer.component';
import { MetadataService } from 'app/shared/services/meta-data-service/meta-data.service';
import { BreadcrumbsService, IBreadcrumb } from 'app/shared/services/breadcrumbs/breadcrumbs.service';

@Component({
  selector: 'news-archive',
  templateUrl: './news-archive.component.html',
  styleUrls: ['./news-archive.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone:true,
  imports:[PagedVirtualScrollerComponent, BlockHorizontalScrollerComponent, NewsBlockComponent, RenderIfDirective, ToolbarHallsComponent, FooterComponent, NewsArchiveHeaderComponent, NewsArchiveHeaderResponsiveComponent, CarouselBannerComponent, FiltersComponent, PagedVirtualScrollerComponent_1, NewsBlockSocialComponent]
})
export class NewsArchiveComponent implements OnInit {
  breadcrumb: IBreadcrumb[];
  newsQuery: QueryRef<NewsResponse>;

  constructor(
    public usersService: UsersService,
    private languagesService: LanguagesService,
    private metadataService: MetadataService,
    private breadcrumbsService: BreadcrumbsService,
    private newsGQL: NewsGQL
  ){}

  ngOnInit() {

    this.breadcrumb = [
      {
        label: $localize`News`,
        url: "/news"
      },
      {
        label: $localize`Expometals Insider`,
        url: "/insider"
      }
    ]
    this.breadcrumbsService.store(this.breadcrumb);

    this.metadataService.appendMetadata({
      title: $localize`Expometals Insider`,
      description: $localize`Directly from inside the industry: news, trends, and insights from our editorial team`,
      images: ['assets/expometals-social.png'],
      pageType: 'website',
    },
    null,
    'auto');

    this.metadataService.appendRSSLink(true, this.languagesService.getCurrentLangCode())

    this.newsQuery = this.newsGQL.watch({
      lang: this.languagesService.getCurrentLangCode(),
      newsType: NewsTypeEnum.portal,
      newsStatus: NewsStatusEnum.portalLevelValidated,
      first: 6
      });
  }

}
